<ndt-account-call-history-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns"
   [hangupActiveCallsPrivileges]="hangupActiveCallsPrivileges$ | async"
   [callRecordingsPrivileges]="callRecordingsPrivileges$ | async"
   [callRecordingsLCSPrivileges]="callRecordingsLCSPrivileges$ | async"
   [isSystemUser]="isSystemUser$ | async"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
   (openDialog)="onOpenDialog($event)"
   (listen)="onListen($event)"
   (quickFilterChange)="onQuickFilterChange($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
></ndt-account-call-history-register-view>
